/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Flow_Out_1Inputs */

const en_services_flow_out_1 = /** @type {(inputs: Services_Flow_Out_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer reply`)
};

const lv_services_flow_out_1 = /** @type {(inputs: Services_Flow_Out_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbilde klientam`)
};

/**
* | output |
* | --- |
* | "Customer reply" |
*
* @param {Services_Flow_Out_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_flow_out_1 = /** @type {((inputs?: Services_Flow_Out_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Flow_Out_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_flow_out_1(inputs)
	return en_services_flow_out_1(inputs)
});